import React from "react";

import { Routes, Route } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";

//const navItems = ['Home', 'About Us', 'Products and Services', 'Contact', 'Privacy'];
const rootUrl = "/propedge";

const navItems = [
  { name: "Home", path: rootUrl },
  { name: "Privacy", path: `${rootUrl}/privacy` },
];

export default function App() {
  return (
    <Routes>
      <Route element={<MainLayout navItems={navItems} />}>
        <Route path={`${rootUrl}`} element={<Home />} />
        <Route path={`${rootUrl}/privacy`} element={<Privacy />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}
